import { render, staticRenderFns } from "./FeedbackItem.vue?vue&type=template&id=129b4742"
import script from "./FeedbackItem.vue?vue&type=script&lang=ts"
export * from "./FeedbackItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports